var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"polls-page-info-tab"},[_c('active-info-page',{attrs:{"scope":{poll: _vm.poll},"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }